import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer id="contact" className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-column">
            <h3 className="footer-logo">
              <span className="logo-text">Offer Lifetime</span>
              <span className="logo-hash">#</span>
            </h3>
            <p className="footer-tagline">
              Your trusted platform for transparent and fair prize opportunities. Join our community and experience the thrill of winning.
            </p>
            <div className="footer-social">
              <a href="https://www.facebook.com/share/BGN8Hsn5brW3ymSZ/" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">
                <i data-lucide="facebook"></i>
              </a>
              <a href="https://www.instagram.com/invites/contact/?igsh=ujoji6x0nujz&utm_content=wafs0kc" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                <i data-lucide="instagram"></i>
              </a>
              <a href="https://www.youtube.com/@OfferLifeTime" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="YouTube">
                <i data-lucide="youtube"></i>
              </a>
              <a href="https://x.com/offerlifetime?t=TTgHyI3oS3VQdffTGYTXPA&s=08" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="X (Twitter)">
                <i data-lucide="twitter"></i>
              </a>
              <a href="https://www.linkedin.com/in/offer-lifetime-tm-b2806933a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn">
                <i data-lucide="linkedin"></i>
              </a>
            </div>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#prizes">Prizes</a></li>
              <li><a href="#winners">Winners</a></li>
              <li><Link to="/admin/login">Admin Panel</Link></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Contact</h4>
            <div className="contact-info">
              <div className="contact-item">
                <i data-lucide="mail" className="contact-icon"></i>
                <div>
                  <p className="contact-label">Email:</p>
                  <a href="mailto:support@offerlifetime.com">support@offerlifetime.com</a>
                </div>
              </div>
              <div className="contact-item">
                <i data-lucide="phone" className="contact-icon"></i>
                <div>
                  <p className="contact-label">Phone:</p>
                  <a href="tel:+918818001860">+91 8818001860</a>
                </div>
              </div>
              <div className="contact-item">
                <i data-lucide="message-circle" className="contact-icon"></i>
                <div>
                  <p className="contact-label">WhatsApp:</p>
                  <a href="https://wa.me/918818001860" target="_blank" rel="noopener noreferrer">+91 8818001860</a>
                </div>
              </div>
              <div className="contact-item">
                <i data-lucide="map-pin" className="contact-icon"></i>
                <div>
                  <p className="contact-label">Address:</p>
                  <p>VPO BATTA TH. KALAYAT<br />DISST. KAITHAL HARYANA<br />INDIA-136117</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">© 2024 Offer Lifetime#. All rights reserved.</p>
          <div className="footer-legal">
            <Link to="/terms">Terms & Conditions</Link>
            <Link to="/disclaimer">Disclaimer</Link>
            <a href="#">Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
